// extracted by mini-css-extract-plugin
export default {"navigation_buttons":"NavigationButtons_navigation_buttons__EvDZF","shimmer":"NavigationButtons_shimmer__I34jI"};